<template>
  <div class="my-text">
    <template v-if="props.mode === 'tags' && Array.isArray(displayValue)">
      <a-tag v-for="(tag, index) in displayValue" :key="`${tag}-${index}`" class="my-text-tag">{{ tag }}</a-tag>
    </template>
    <template v-else>{{ displayValue }}</template>
  </div>
</template>

<script setup>
  import { computed, defineProps } from 'vue';
  import { dateFormat } from '@/utils';
  const props = defineProps({
    modelValue: {
      type: [String, Number, Array, Object],
    },
    mode: {
      type: [String], 
    },
    format: {
      type: [Function],
    },
    onGetFormData: {
      type: [Function],
    },
    defaultValue: {
      type: [String, Number, Boolean],
    }
  });

  const format = () => {
    const formData = typeof props.onGetFormData == 'function' ? props.onGetFormData() : {};
    if (props.format) {
      return props.format(props.modelValue, formData);
    }
    if (!props.mode) {
      return props.modelValue;
    }
    if (props.mode == 'time') {
      return dateFormat(props.modelValue, 'YYYY/MM/DD HH:mm:ss');
    }
    if (props.mode == 'date') {
      return dateFormat(props.modelValue, 'YYYY/MM/DD');
    }
  }
  const displayValue = computed(format);

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .my-text {
    display: inline-block;
    width: 100%;
    margin: 4px 0;
    padding-right: 12px;
    word-break: break-all;
  }
  .my-text-tag {
    margin-bottom: 4px;
  }
</style>
